import VisitedAccountsList from './VisitedAccountsList';

export default VisitedAccountsList;
